import {CardContent, makeStyles, Typography } from '@material-ui/core';
import { useSpring, animated } from 'react-spring'
import React from 'react';
import ReactTypingEffect from 'react-typing-effect';
import shape from '../images/hexa.png'
import hair from '../images/pelo.png'
import face from '../images/cara.png'


const calc = (x, y, z) => [x - window.innerWidth / 3, y - window.innerHeight / 2, z - window.innerHeight / 5]
const trans1 = (x, y) => `translate3d(${x / 20}px,${y / 10}px,0)`
const trans2 = (x, y) => `translate3d(${x / -25}px,${y / -19}px,0)`
const trans3 = (x, y) => `translate3d(${x / -20}px,${y / -10}px,0)`



const About = ({ id}) => {
    const classes = useStyles();
    const [props, set] = useSpring(() => ({ xyz: [0, 0, 0], config: { mass: 1,
        tension: 170,
        friction: 26,
        clamp: true,
        precision: 0.01,
        velocity: 0,
        easing: (t) => t
      } }))

    return (
        <div className ={`${classes.section} ${ classes.sectiondark}`}>
            <div className={classes.sectioncontent} id={ id}>
            <Typography className={classes.hello}>Hello!</Typography>

                <div className={classes.containerDraw} onMouseMove={({ clientX: x, clientY: y , clientZ: z}) => set({ xyz: calc(x, y, z) })}>
                <animated.div className={classes.shape} style={{ transform: props.xyz.interpolate(trans1) }} >
                    <img src={shape} alt=''/>
                    </animated.div>
                    <animated.div className={classes.shape} style={{ transform: props.xyz.interpolate(trans2) }} >
                    <img src={hair} alt=''/>

                    </animated.div>
                    <animated.div className={classes.shape} style={{ transform: props.xyz.interpolate(trans3) }} >
                    <img src={face} alt='' />

                    </animated.div>
                </div>
                    <CardContent className={classes.cardcontent}>

                     <Typography className={classes.statictext}>I'm a</Typography>
                    <ReactTypingEffect
                        text={['Graphic Designer',
                              'UI-UX Designer',
                              'Frontend developer']}
                        className={classes.descriptionabout}
                        typingDelay={60}
                        cursorColor="black"
                        eraseSpeed={40}
                        speed={40}
                        displayTextRenderer={(text, i) => {
                            return (
                              <p>
                                {text.split('').map((char, i) => {
                                  const key = `${i}`;
                                  return (
                                    <span
                                      key={key}
                                      className={classes.profession}
                                    >{char}</span>
                                  );
                                })}
                              </p>
                            );
                          }}        
                    />
                    
                    </CardContent>
      
            </div>
        </div>
    )
}


const useStyles = makeStyles((theme) => ({
    section: {
        minHeight: "100vh",
        paddingTop:'100px'
    },

    sectiondark: {
        background:  "linear-gradient(45deg, #182052 20%, #5b4a69 80%)",
        color: "#fff",
    },
    sectioncontent:{
        maxWidth: "100%",
        display:'flex',
        justifyContent:'space-between',
        margin:'0px auto',

        alignItems:'center',
        padding: theme.spacing(5),
        [theme.breakpoints.down('sm')]:{
            padding: theme.spacing(2),
            justifyContent:'center',
            flexDirection:'column',
        }
    },
    containerDraw:{
        '& img':{
            width:'70%',
            margin:'70px 60%'
        },
         [theme.breakpoints.down('sm')]:{
             '& img':{
            width:'95%',
            margin:'60px 0px',
      
             },
        }
    },
    hello:{
        fontSize:'5em',
        fontWeight:'900',
        top:'100px',
        position:'absolute',
        left:'200px'
    },
    statictext:{
        fontSize:'3em',
       [theme.breakpoints.down('sm')]:{
           fontSize: "3rem",
            padding: "0px",
        }
    },
    cardcontent:{
        display: "flex",
        flexDirection: "column",
        width:'500px',
        paddingTop:'350px',
       [theme.breakpoints.down('sm')]:{
            marginTop:'200px',
            width:'100%',
            marginLeft:'70px'
      },
    },
   
    shape:{
        position:'absolute',
        top:'0',
        left:'8%',
        
    },
    descriptionabout: {
        fontSize: "3rem",
        color:"#cbcbcb",
        textAlign:'left',
        [theme.breakpoints.down('sm')]:{
            fontSize: "2rem",
            padding: "10px 0px",
        }
    },
    profession:{
        fontWeight:"bold",
        color:"#8d6189",
        [theme.breakpoints.down('sm')]:{
            fontSize: "1.rem",
           
        }
    },
 

}))


export default About

